<div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>

<div mat-dialog-title class="d-flex flex-column position-relative" *ngIf="!loader">
    <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent"
    >
      <mat-icon>close</mat-icon>
    </button>
    <div class="profile-title d-flex flex-column align-items-center">
      <img
        [src]="
        metadata[0]['imageThumbUrl'] && metadata[0]['imageThumbUrl'] !== null && metadata[0]['imageThumbUrl'] !== 'null'
            ? metadata[0]['imageThumbUrl']
            : './assets/images/user-avatar.svg'
        "
        class="img-fluid rounded-circle mx-auto mb-4"
      />
      <h2 class="mb-0">{{ metadata[0].name | titlecase }}</h2>
    </div>
  </div>
  <mat-dialog-content *ngIf="!loader">
    <mat-list>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">info</mat-icon>
        <div mat-line>
          Address: <span>{{ metadata[0].userLocation.address_line }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >account_circle</mat-icon
        >
        <div mat-line>
          Gender: <span>{{ metadata[0].gender }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Date of birth: <span>{{ metadata[0].dob | date}}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <!-- <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          Phone number: <span>{{ data.phone }}</span>
        </div>
      </mat-list-item> -->
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >admin_panel_settings</mat-icon
        >
        <div mat-line>
          Phone: <span>{{ metadata[0].phone }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
          Short bio: <span>{{ metadata[0].short_bio}}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          User Type: <span>{{ metadata[0].user_type }}</span>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-dialog-content>